import React, { useContext, useState, useEffect, useLayoutEffect, useReducer, useRef } from "react";
import { parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  getStoredCompanyTimezone,
  resolveCompanyTimezone
} from "../../utils/companyTimezone";
import moment from "moment-timezone";
import clsx from "clsx";
import { isNil } from "lodash";
import { blue, green } from "@material-ui/core/colors";
import {
  Button,
  Divider,
  Typography,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  makeStyles
} from "@material-ui/core";

import {
  AccessTime,
  Done,
  DoneAll,
  ExpandMore,
  InsertEmoticon,
  GetApp,
  Facebook,
  Instagram,
  Reply,
  WhatsApp,
  KeyboardArrowDown,
  Chat,
  FileCopy
} from "@material-ui/icons";
import LockIcon from '@material-ui/icons/Lock';
import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
import whatsBackground from "../../assets/wa-background.png";
import whatsBackgroundDark from "../../assets/wa-background-dark.png";
import YouTubePreview from "../ModalYoutubeCors";
import { getTicketDisplayNumber } from "../../utils/ticketNumber";
import PdfPreview from "../PdfPreview";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import AdMetaPreview from "../AdMetaPreview";
import FacebookPostPreview from "../FacebookPostPreview";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { toast } from "react-toastify";
import SelectMessageCheckbox from "./SelectMessageCheckbox";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";
import AudioModal from "../AudioModal";
import { CircularProgress } from "@material-ui/core";
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { downloadResource } from "../../utils";
import Template from "./templates";
import { usePdfViewer } from "../../hooks/usePdfViewer";
import ReactionPicker from "../ReactionPicker";
import DateSeparator from "./DateSeparator";

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    minWidth: 300,
    minHeight: 200,
  },

  currentTick: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "95%",
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || theme.palette.primary.main} 100%)`,
    margin: "16px auto",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2), 0 3px 6px rgba(0, 0, 0, 0.15)",
    },
  },

  currentTicktText: {
    color: "#ffffff",
    fontWeight: 600,
    padding: 12,
    alignSelf: "center",
    marginLeft: "0px",
    fontSize: "13px",
    letterSpacing: "0.02em",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
  },

  messagesList: {
    backgroundImage: theme.mode === 'light' ? `url(${whatsBackground})` : `url(${whatsBackgroundDark})`,
    backgroundColor: theme.mode === 'light' ? "transparent" : "#0b0b0d",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px", // ✅ CORREÇÃO: Padding-bottom de 20px para espaço mínimo entre última mensagem e caixa de digitar
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  dragElement: {
    background: 'rgba(255, 255, 255, 0.8)',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 999999,
    textAlign: "center",
    fontSize: "3em",
    border: "5px dashed #333",
    color: '#333',
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  circleLoading: {
    color: blue[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },
  scrollToLatestButton: {
    position: "absolute",
    right: 24,
    bottom: 24,
    width: 44,
    height: 44,
    minWidth: 44,
    borderRadius: "50%",
    zIndex: 12,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#202c33",
    color: theme.mode === "light" ? "#3b4a54" : "#e9edef",
    boxShadow: theme.mode === "light"
      ? "0 4px 14px rgba(0, 0, 0, 0.18)"
      : "0 4px 16px rgba(0, 0, 0, 0.45)",
    border: theme.mode === "light" ? "1px solid rgba(0, 0, 0, 0.08)" : "1px solid rgba(255, 255, 255, 0.08)",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#f5f6f6" : "#2a3942",
    }
  },

  "@global": {
    ".clickable-phone-number": {
      color: "#027eb5",
      cursor: "pointer",
      textDecoration: "none",
      borderBottom: "1px dashed #027eb5",
      transition: "all 0.15s ease",
      "&:hover": {
        color: "#025e8a",
        borderBottomStyle: "solid",
        backgroundColor: "rgba(2, 126, 181, 0.06)",
        borderRadius: 2,
      },
    },
  },
  phoneMenuPaper: {
    minWidth: 300,
    maxWidth: "min(420px, calc(100vw - 32px))",
  },
  phoneMenuItem: {
    alignItems: "flex-start",
    whiteSpace: "normal",
  },
  phoneMenuText: {
    marginTop: 2,
    "& .MuiListItemText-primary": {
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      lineHeight: 1.25,
    },
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 4,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    animation: "$messageSlideIn 0.3s ease-out",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: theme.mode === 'light' 
        ? "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)" 
        : "0 4px 12px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    color: theme.mode === 'light' ? "#303030" : "#e9edef",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 6,
    boxShadow: theme.mode === 'light' 
      ? "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)" 
      : "0 2px 8px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10px)",
    border: theme.mode === 'light' 
      ? "1px solid rgba(0, 0, 0, 0.04)" 
      : "1px solid rgba(255, 255, 255, 0.08)",
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.mode === 'light' ? "#f0f0f0" : "#1d282f",
    borderRadius: "10px",
    display: "flex",
    position: "relative",
    border: theme.mode === 'light' 
      ? "1px solid rgba(0, 0, 0, 0.06)" 
      : "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    background: "linear-gradient(180deg, #388aff 0%, #2d6aff 100%)",
    borderRadius: "10px 0 0 10px",
  },

  messageRight: {
    marginLeft: 20,
    marginRight: 20,
    marginTop: 4,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    animation: "$messageSlideIn 0.3s ease-out",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: theme.mode === 'light' 
        ? "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)" 
        : "0 4px 12px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    whiteSpace: "pre-wrap",
    background: theme.mode === 'light' 
      ? "linear-gradient(135deg, #dcf8c6 0%, #d4f0b8 100%)" 
      : "linear-gradient(135deg, #005c4b 0%, #004d3f 100%)",
    color: theme.mode === 'light' ? "#303030" : "#e9edef",
    alignSelf: "flex-end",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 0,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 6,
    boxShadow: theme.mode === 'light' 
      ? "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)" 
      : "0 2px 8px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10px)",
    border: theme.mode === 'light' 
      ? "1px solid rgba(0, 0, 0, 0.04)" 
      : "1px solid rgba(255, 255, 255, 0.08)",
  },

  messageRightPrivate: {
    marginLeft: 20,
    marginRight: 20,
    marginTop: 4,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    animation: "$messageSlideIn 0.3s ease-out",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
    },
    whiteSpace: "pre-wrap",
    background: "linear-gradient(135deg, #F0E68C 0%, #E6D97A 100%)",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 0,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 6,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(0, 0, 0, 0.04)",
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: theme.mode === 'light' ? "#cfe9ba" : "#025144",
    borderRadius: "10px",
    display: "flex",
    position: "relative",
    border: theme.mode === 'light' 
      ? "1px solid rgba(0, 0, 0, 0.06)" 
      : "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    background: "linear-gradient(180deg, #35cd96 0%, #2ab882 100%)",
    borderRadius: "10px 0 0 10px",
  },

  messageActionsButton: {
    display: "flex",
    color: "#999",
    backgroundColor: "transparent",
    padding: "6px",
    minWidth: "auto",
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover, &.Mui-focusVisible": { 
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      opacity: "100%",
      color: "#666",
      transform: "scale(1.1)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  },

  messageRow: {
    width: "100%",
    display: "flex",
    position: "relative",
    marginTop: 8,
    "&:hover $messageOutsideActions": {
      opacity: 1,
    },
    "&:hover $messageMenuInside": {
      opacity: 1,
    },
  },

  messageRowLeft: {
    justifyContent: "flex-start",
    paddingRight: 44,
  },

  messageRowRight: {
    justifyContent: "flex-end",
    paddingLeft: 44,
  },

  messageBubbleAnchor: {
    position: "relative",
    display: "inline-block",
    maxWidth: 600,
  },

  messageOutsideActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    position: "absolute",
    top: 6,
    zIndex: 100,
    opacity: "0",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  messageOutsideActionsLeft: {
    right: -37,
  },

  messageOutsideActionsRight: {
    left: -37,
  },

  messageMenuInside: {
    position: "absolute",
    top: 4,
    zIndex: 101,
    opacity: "0",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  messageMenuInsideLeft: {
    right: 4,
  },

  messageMenuInsideRight: {
    left: 8,
  },

  messageActionsButtonInside: {
    opacity: 0.72,
    backgroundColor: theme.mode === 'light'
      ? "rgba(255, 255, 255, 0.72)"
      : "rgba(0, 0, 0, 0.28)",
    color: theme.mode === 'light' ? "#4f5b62" : "#d1d7db",
    boxShadow: theme.mode === 'light'
      ? "0 1px 4px rgba(0, 0, 0, 0.08)"
      : "0 1px 4px rgba(0, 0, 0, 0.2)",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 600,
    fontSize: "13px",
    marginBottom: "4px",
    letterSpacing: "0.01em",
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "4px 80px 8px 6px",
    lineHeight: "1.5",
    fontSize: "14.2px",
    letterSpacing: "0.01em",
    wordSpacing: "0.05em",
  },

  textContentItemOutgoing: {
    paddingLeft: 34,
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemDeletedOutgoing: {
    paddingLeft: 34,
  },

  mediaWrapper: {
    marginTop: "5px", // ✅ Espaço superior (3px do texto + 2px = 5px)
  },

  messageMedia: {
    width: 400,
    height: "auto",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginBottom: theme.spacing(2),
    position: "relative",
    zIndex: 1,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)",
    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)",
    },
    "&[controls]": {
      objectFit: "contain",
    }
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 4,
    right: 8,
    color: theme.mode === 'light' ? "#667781" : "#8696a0",
    zIndex: 10,
    backgroundColor: theme.mode === 'light' 
      ? "rgba(255, 255, 255, 0.85)" 
      : "rgba(0, 0, 0, 0.3)",
    padding: "3px 6px",
    borderRadius: 8,
    fontWeight: 400,
    letterSpacing: "0.01em",
    backdropFilter: "blur(8px)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
  },

  timestampIncoming: {
    background: theme.mode === "light"
      ? "linear-gradient(135deg, #dcf8c6 0%, #d4f0b8 100%)"
      : "linear-gradient(135deg, #005c4b 0%, #004d3f 100%)",
    color: theme.mode === "light" ? "#667781" : "#d8fdd2",
  },

  forwardMessage: {
    fontSize: 12,
    fontStyle: "italic",
    position: "absolute",
    top: 0,
    left: 5,
    color: "#999",
    display: "flex",
    alignItems: "center"
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: blue[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  ackPlayedIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },
  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
    color: theme.mode === "light" ? theme.palette.light : theme.palette.dark,
  },

  messageCenter: {
    marginTop: 8,
    alignItems: "center",
    verticalAlign: "center",
    alignContent: "center",
    backgroundColor: theme.mode === 'light' 
      ? "rgba(225, 245, 254, 0.9)" 
      : "rgba(32, 44, 51, 0.9)",
    fontSize: "12px",
    minWidth: 100,
    maxWidth: 270,
    color: theme.mode === 'light' ? "#272727" : "#e9edef",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 6,
    boxShadow: theme.mode === 'light' 
      ? "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)" 
      : "0 2px 8px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10px)",
    border: theme.mode === 'light' 
      ? "1px solid rgba(0, 0, 0, 0.04)" 
      : "1px solid rgba(255, 255, 255, 0.08)",
    transition: "all 0.2s ease",
  },

  deletedMessage: {
    color: '#f55d65'
  },
  
  "@keyframes messageSlideIn": {
    "0%": {
      opacity: 0,
      transform: "translateY(10px) scale(0.95)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0) scale(1)",
    },
  },

  // ✅ REACTIONS: Estilos para reações
  reactionsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px",
    marginTop: "4px",
    marginBottom: "2px",
    padding: "2px 0",
  },

  reactionPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 6px",
    borderRadius: "12px",
    backgroundColor: theme.mode === 'light' 
      ? "rgba(0, 0, 0, 0.05)" 
      : "rgba(255, 255, 255, 0.1)",
    fontSize: "12px",
    lineHeight: "1.2",
    cursor: "default",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.mode === 'light' 
        ? "rgba(0, 0, 0, 0.08)" 
        : "rgba(255, 255, 255, 0.15)",
    },
  },

  reactionEmoji: {
    fontSize: "14px",
    lineHeight: "1",
  },

  reactionCount: {
    fontSize: "11px",
    fontWeight: 500,
    color: theme.mode === 'light' ? "#667781" : "#8696a0",
    minWidth: "12px",
    textAlign: "center",
  },
  focusedMessage: {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
    animation: "$focusedPulse 1.6s ease"
  },
  "@keyframes focusedPulse": {
    "0%": {
      transform: "scale(0.98)"
    },
    "50%": {
      transform: "scale(1.01)"
    },
    "100%": {
      transform: "scale(1)"
    }
  }
}));

const normalizeMessageReactions = (message) => {
  if (!message) return message;

  const normalized = { ...message };

  if (typeof normalized.reactions === "string") {
    try {
      normalized.reactions = JSON.parse(normalized.reactions);
    } catch (_error) {
      normalized.reactions = [];
    }
  }

  if (!Array.isArray(normalized.reactions)) {
    normalized.reactions = [];
  }

  return normalized;
};

const normalizeMessageId = (id) => String(id ?? "");
const normalizeTicketKey = (id) => String(id ?? "");

const getMessageKey = (message) => {
  const id = normalizeMessageId(message?.id);
  if (id) return `id:${id}`;
  if (message?.wid) return `wid:${message.wid}`;
  return "";
};

const compareMessagesAsc = (a, b) => {
  const dateA = new Date(a?.createdAt || 0).getTime();
  const dateB = new Date(b?.createdAt || 0).getTime();

  if (dateA !== dateB) {
    return dateA - dateB;
  }

  const idA = Number(a?.id || 0);
  const idB = Number(b?.id || 0);

  if (!Number.isNaN(idA) && !Number.isNaN(idB) && idA !== idB) {
    return idA - idB;
  }

  return normalizeMessageId(a?.id).localeCompare(normalizeMessageId(b?.id));
};

const mergeMessages = (currentMessages = [], incomingMessages = []) => {
  const byKey = new Map();

  currentMessages.map(normalizeMessageReactions).forEach((message) => {
    const key = getMessageKey(message);
    if (key) byKey.set(key, message);
  });

  incomingMessages.map(normalizeMessageReactions).forEach((message) => {
    const key = getMessageKey(message);
    if (!key) return;
    byKey.set(key, { ...(byKey.get(key) || {}), ...message });
  });

  return Array.from(byKey.values()).sort(compareMessagesAsc);
};

const getMessagesAuditSummary = (messages = []) => {
  const list = Array.isArray(messages) ? messages : [];
  return {
    count: list.length,
    firstId: list[0]?.id || null,
    lastId: list[list.length - 1]?.id || null
  };
};

const sameTicket = ({ selectedTicket, message, ticket }) => {
  const selectedIds = [
    selectedTicket?.key,
    selectedTicket?.id,
    selectedTicket?.dbId,
    selectedTicket?.uuid
  ].map(value => String(value || "")).filter(Boolean);

  const payloadIds = [
    message?.ticketId,
    message?.ticket?.id,
    message?.ticket?.uuid,
    ticket?.id,
    ticket?.uuid
  ].map(value => String(value || "")).filter(Boolean);

  return selectedIds.some(selected => payloadIds.includes(selected));
};

const resolveReactionPayload = (message, emoji) => {
  const ownReaction = Array.isArray(message?.reactions)
    ? message.reactions.find((reaction) => reaction?.fromMe === true)
    : null;

  if (ownReaction?.emoji === emoji) {
    return "";
  }

  return emoji;
};

const capitalizeFirstLetter = (value = "") =>
  value.charAt(0).toUpperCase() + value.slice(1);

const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const ticketKey = normalizeTicketKey(action.ticketId);
    if (!ticketKey) return state;
    const currentMessages = state[ticketKey] || [];
    const incomingMessages = action.payload || [];
    const mergedMessages = mergeMessages(currentMessages, incomingMessages);
    const summary = getMessagesAuditSummary(mergedMessages);

    console.log("[REDUCER_LOAD_MESSAGES]", {
      ticketId: ticketKey,
      countBefore: currentMessages.length,
      countIncoming: incomingMessages.length,
      countAfter: summary.count,
      firstId: summary.firstId,
      lastId: summary.lastId
    });

    return {
      ...state,
      [ticketKey]: mergedMessages
    };
  }

  if (action.type === "RESET_TICKET_MESSAGES") {
    const ticketKey = normalizeTicketKey(action.ticketId);
    if (!ticketKey) return state;
    const currentMessages = state[ticketKey] || [];

    console.log("[REDUCER_RESET]", {
      ticketId: ticketKey,
      countBefore: currentMessages.length
    });

    return {
      ...state,
      [ticketKey]: currentMessages
    };
  }

  if (action.type === "ADD_MESSAGE") {
    const ticketKey = normalizeTicketKey(action.ticketId || action.payload?.ticket?.uuid || action.payload?.ticket?.id || action.payload?.ticketId);
    if (!ticketKey) return state;

    const newMessage = normalizeMessageReactions(action.payload);
    const newMessageKey = getMessageKey(newMessage);
    if (!newMessageKey) {
      console.error("[MESSAGES_REDUCER] ADD_MESSAGE inválido", newMessage);
      return state;
    }
    const currentMessages = state[ticketKey] || [];
    const mergedMessages = mergeMessages(currentMessages, [newMessage]);

    console.log("[REDUCER_ADD_MESSAGE]", {
      ticketId: ticketKey,
      messageId: newMessage.id || newMessage.wid || null,
      countBefore: currentMessages.length,
      countAfter: mergedMessages.length
    });

    return {
      ...state,
      [ticketKey]: mergedMessages
    };
  }

  if (action.type === "UPDATE_MESSAGE") {
    const ticketKey = normalizeTicketKey(action.ticketId || action.payload?.ticket?.uuid || action.payload?.ticket?.id || action.payload?.ticketId);
    if (!ticketKey) return state;

    const updatedMessage = normalizeMessageReactions(action.payload);
    const updatedMessageKey = getMessageKey(updatedMessage);
    if (!updatedMessageKey) {
      console.error("[MESSAGES_REDUCER] UPDATE_MESSAGE inválido", updatedMessage);
      return state;
    }
    const currentMessages = state[ticketKey] || [];
    const mergedMessages = mergeMessages(currentMessages, [updatedMessage]);

    console.log("[REDUCER_UPDATE_MESSAGE]", {
      ticketId: ticketKey,
      messageId: updatedMessage.id || updatedMessage.wid || null,
      countBefore: currentMessages.length,
      countAfter: mergedMessages.length
    });

    return {
      ...state,
      [ticketKey]: mergedMessages
    };
  }

  if (action.type === "DELETE_MESSAGE") {
    const ticketKey = normalizeTicketKey(action.ticketId);
    const messageId = action.payload;
    if (!ticketKey || !messageId) {
      return state;
    }
    const normalizedDeleteId = normalizeMessageId(messageId);
    return {
      ...state,
      [ticketKey]: (state[ticketKey] || []).filter((message) => normalizeMessageId(message?.id) !== normalizedDeleteId)
    };
  }

  return state;
};

const MessagesList = ({
  isGroup,
  onDrop,
  ticketDbId,
  ticketUuid,
  whatsappId,
  queueId,
  channel,
  ticketStatus
}) => {
  const classes = useStyles();
  const [messagesByTicket, dispatch] = useReducer(reducer, {});
  const [pageNumberByTicket, setPageNumberByTicket] = useState({});
  const [hasMoreByTicket, setHasMoreByTicket] = useState({});
  const [loadingByTicket, setLoadingByTicket] = useState({});
  const [loadingMoreByTicket, setLoadingMoreByTicket] = useState({});
  const [initializedByTicket, setInitializedByTicket] = useState({});
  const [showScrollToLatest, setShowScrollToLatest] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const messagesContainerRef = useRef(null);
  const lastMessageRef = useRef();
  const messageRefs = useRef({});

  const [selectedMessage, setSelectedMessage] = useState({});
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);

  const [phoneMenuAnchorEl, setPhoneMenuAnchorEl] = useState(null);
  const [phoneMenuNumber, setPhoneMenuNumber] = useState("");
  const [phoneMenuMeta, setPhoneMenuMeta] = useState({
    isPhone: false,
    displayValue: "",
    copyValue: ""
  });
  const [openingPhoneTicket, setOpeningPhoneTicket] = useState(false);
  const phoneMenuOpen = Boolean(phoneMenuAnchorEl);

  const handlePhoneClick = (value, anchorElement, meta = {}) => {
    console.log("[PHONE_LINK_CLICK]", { value, isPhone: meta.isPhone, sourceTicketId: ticketDbId, sourceWhatsappId: whatsappId });
    setPhoneMenuNumber(value);
    setPhoneMenuMeta({
      isPhone: Boolean(meta.isPhone),
      displayValue: meta.displayValue || value,
      copyValue: meta.copyValue || value
    });
    setPhoneMenuAnchorEl(anchorElement);
  };

  const handleClosePhoneMenu = () => {
    setPhoneMenuAnchorEl(null);
  };

  const handleTalkToPhone = async () => {
    const targetPhone = phoneMenuMeta.isPhone ? phoneMenuNumber : "";
    handleClosePhoneMenu();

    if (!targetPhone || openingPhoneTicket) return;

    setOpeningPhoneTicket(true);

    try {
      const { data } = await api.post("/contacts/quick-message-draft", {
        phone: targetPhone,
        sourceWhatsappId: whatsappId || null,
        sourceTicketId: ticketDbId || null
      });

      if (data?.uuid) {
        history.push(`/tickets/${data.uuid}`);
      }
    } catch (err) {
      toastError(err);
    } finally {
      setOpeningPhoneTicket(false);
    }
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  const handleCopyPhone = async () => {
    try {
      await copyTextToClipboard(phoneMenuMeta.copyValue || phoneMenuNumber);
      toast.success(i18n.t("ticketInfo.phonecopied"));
    } catch (err) {
      toast.error(i18n.t("ticketInfo.copyError"));
    }

    handleClosePhoneMenu();
  };

  const { ticketId } = useParams();
  const ticketKey = normalizeTicketKey(ticketId);
  const messagesList = messagesByTicket[ticketKey] || [];
  const lastMessageKey = getMessageKey(messagesList[messagesList.length - 1]) || null;
  const pageNumber = pageNumberByTicket[ticketKey] || 1;
  const hasMore = hasMoreByTicket[ticketKey] || false;
  const loading = loadingByTicket[ticketKey] || false;
  const loadingMore = loadingMoreByTicket[ticketKey] || false;
  const initialized = initializedByTicket[ticketKey] || false;

  const currentTicketId = useRef(ticketId);
  const selectedTicketRef = useRef({});
  const messagesByTicketRef = useRef(messagesByTicket);
  const requestSeqRef = useRef(0);
  const ticketIdentityByKey = useRef({});
  const pendingPrependScrollRef = useRef(null);
  const initialScrollPendingRef = useRef(null);
  const pendingSocketAutoScrollRef = useRef(null);
  const { getAll } = useCompanySettings();
  const [dragActive, setDragActive] = useState(false);
  const [dragTimeout, setDragTimeout] = useState(null);

  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState(false);
  const { selectedQueuesMessage } = useContext(QueueSelectedContext);

  // Hook simplificado para PDF
  const {
    downloadPdf,
    extractPdfInfoFromMessage,
    isPdfUrl
  } = usePdfViewer();

  const {
    showSelectMessageCheckbox,
    setSelectedMessages,
    setShowSelectMessageCheckbox,
    setForwardMessageModalOpen
  } = useContext(ForwardMessageContext);
  const { user, socket } = useContext(AuthContext);
  const companyId = user.companyId;
  const companyTimezone = resolveCompanyTimezone(user?.company?.timezone || getStoredCompanyTimezone());

  useEffect(() => {
    messagesByTicketRef.current = messagesByTicket;
  }, [messagesByTicket]);

  useEffect(() => {
    selectedTicketRef.current = {
      key: ticketKey,
      id: ticketId,
      dbId: ticketDbId,
      uuid: ticketUuid
    };
  }, [ticketKey, ticketId, ticketDbId, ticketUuid]);

  console.log(`[TZ_CHAT_RENDER] Messages list render: companyTimezone=${companyTimezone}`);

  const safeFormatDate = (value, fmt = "HH:mm") => {
    if (!value) return "--:--";
    try {
      return moment.utc(value).tz(companyTimezone).format(fmt);
    } catch (_error) {
      return "--:--";
    }
  };

  const getMessagesContainer = () => messagesContainerRef.current || document.getElementById("messagesList");

  const getScrollSnapshot = () => {
    const element = getMessagesContainer();
    if (!element) {
      return {
        scrollTop: null,
        scrollHeight: null,
        clientHeight: null
      };
    }

    return {
      scrollTop: element.scrollTop,
      scrollHeight: element.scrollHeight,
      clientHeight: element.clientHeight
    };
  };

  const isNearBottomElement = (element) => {
    if (!element) return true;
    const distanceFromBottom =
      element.scrollHeight -
      (element.scrollTop + element.clientHeight);

    return distanceFromBottom < 120;
  };

  const updateScrollToLatestVisibility = (element = getMessagesContainer()) => {
    setShowScrollToLatest(!isNearBottomElement(element));
  };

  const logAutoScroll = (reason, before, after) => {
    console.log("[AUTO_SCROLL]", {
      ticketId,
      reason,
      scrollTopBefore: before?.scrollTop ?? null,
      scrollTopAfter: after?.scrollTop ?? null,
      scrollHeight: after?.scrollHeight ?? before?.scrollHeight ?? null,
      clientHeight: after?.clientHeight ?? before?.clientHeight ?? null
    });
  };

  const formatDateSeparatorLabel = (dateVal) => {
    if (!dateVal) return "";
    const localDate = moment.utc(dateVal).tz(companyTimezone);
    const today = moment().tz(companyTimezone);
    if (localDate.format("YYYY-MM-DD") === today.format("YYYY-MM-DD")) {
      return "HOJE";
    }
    if (localDate.format("YYYY-MM-DD") === today.clone().subtract(1, "day").format("YYYY-MM-DD")) {
      return "ONTEM";
    }
    const daysDiff = today.clone().startOf("day").diff(localDate.clone().startOf("day"), "days");
    if (daysDiff <= 6 && daysDiff >= 0) {
      const dayName = localDate.locale("pt-br").format("dddd");
      return dayName.charAt(0).toUpperCase() + dayName.slice(1);
    }
    const formatted = localDate.locale("pt-br").format("D [de] MMMM [de] YYYY");
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  const [quickReactionAnchorEl, setQuickReactionAnchorEl] = useState(null);
  const [quickReactionMessage, setQuickReactionMessage] = useState(null);
  const [focusedMessageId, setFocusedMessageId] = useState(null);
  const focusedApiPageRef = useRef(1);

  useEffect(() => {
    async function fetchData() {
      const settings = await getAll(companyId);

      let settinglgpdDeleteMessage;
      let settingEnableLGPD;

      for (const [key, value] of Object.entries(settings)) {
        if (key === "lgpdDeleteMessage") settinglgpdDeleteMessage = value
        if (key === "enableLGPD") settingEnableLGPD = value
      }
      if (settingEnableLGPD === "enabled" && settinglgpdDeleteMessage === "enabled") {
        setLGPDDeleteMessage(true);
      }
    }
    fetchData();
  }, [])

  useEffect(() => {
    currentTicketId.current = ticketId;
    messageRefs.current = {};
    pendingPrependScrollRef.current = null;
    pendingSocketAutoScrollRef.current = null;
    setShowScrollToLatest(false);

    const currentKey = normalizeTicketKey(ticketId);
    const targetMessageId = new URLSearchParams(location.search).get("focusedMessageId");
    initialScrollPendingRef.current = {
      ticketId: currentKey,
      focusedMessageId: targetMessageId || null,
      source: "ticket_change"
    };
    console.log("[CHAT_OPEN]", {
      ticketId: currentKey,
      ...getScrollSnapshot()
    });
    dispatch({ type: "RESET_TICKET_MESSAGES", ticketId: currentKey });
    setInitializedByTicket(prev => ({ ...prev, [currentKey]: false }));
    setPageNumberByTicket(prev => ({ ...prev, [currentKey]: 1 }));
    setHasMoreByTicket(prev => ({ ...prev, [currentKey]: false }));
    setLoadingMoreByTicket(prev => ({ ...prev, [currentKey]: false }));
  }, [ticketId, location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const targetMessageId = params.get("focusedMessageId");
    setFocusedMessageId(targetMessageId);
    focusedApiPageRef.current = 1;
    if (targetMessageId) {
      const currentKey = normalizeTicketKey(ticketId);
      setInitializedByTicket(prev => ({ ...prev, [currentKey]: false }));
      setPageNumberByTicket(prev => ({ ...prev, [currentKey]: 1 }));
    }
  }, [location.search, ticketId]);

  useEffect(() => {
    if (!ticketKey || ticketId === "undefined") {
      if (ticketId === "undefined") {
        history.push("/tickets");
      }
      return undefined;
    }

    if (initialized && !loadingMore && !focusedMessageId) {
      return undefined;
    }

    const requestId = requestSeqRef.current + 1;
    requestSeqRef.current = requestId;
    setLoadingByTicket(prev => ({ ...prev, [ticketKey]: true }));

    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        if (isNil(ticketId)) return;

        // ✅ GROUP_DEBUG: Log quando busca mensagens via API
        if (import.meta.env.VITE_ENABLE_GROUP_DEBUG === "true") {
          console.log("[GROUP_DEBUG] Fetching messages via API", {
            ticketId,
            endpoint: `/messages/${ticketId}`,
            pageNumber
          });
        }

        try {
          console.log("[LOAD_MESSAGES_START]", {
            ticketId,
            ticketDbId: ticketDbId || null,
            pageNumber,
            requestId
          });
          const { data } = await api.get("/messages/" + ticketId, {
            params: {
              pageNumber,
              selectedQueues: JSON.stringify(selectedQueuesMessage),
              targetMessageId: pageNumber === 1 ? focusedMessageId : undefined
            },
          });
          console.log("[LOAD_MESSAGES_FINISH]", {
            ticketId,
            ticketDbId: data.ticket?.id || ticketDbId || null,
            pageNumber: data.pageNumber || pageNumber,
            requestId,
            count: data.messages?.length || 0
          });

          // ✅ GROUP_DEBUG: Log resposta da API
          if (import.meta.env.VITE_ENABLE_GROUP_DEBUG === "true") {
            console.log("[GROUP_DEBUG] Messages API response", {
              ticketId,
              messagesCount: data?.messages?.length || 0,
              hasMore: data?.hasMore || false,
              ticketIsGroup: data?.ticket?.isGroup || false,
              contactIsGroup: data?.ticket?.contact?.isGroup || false
            });
          }

          if (requestSeqRef.current === requestId && currentTicketId.current === ticketId) {
            ticketIdentityByKey.current[ticketKey] = {
              id: data.ticket?.id || ticketDbId,
              uuid: data.ticket?.uuid || ticketUuid || ticketId
            };
            const loadedMessages = data.messages || [];
            if (pageNumber === 1 && loadedMessages.length > 0) {
              initialScrollPendingRef.current = {
                ticketId: ticketKey,
                focusedMessageId,
                source: "page_one_loaded"
              };
            }
            console.log("[MESSAGES_LOADED]", {
              ticketId,
              ticketDbId: data.ticket?.id || ticketDbId || null,
              count: loadedMessages.length,
              firstMessage: loadedMessages[0] ? {
                id: loadedMessages[0].id,
                body: loadedMessages[0].body,
                createdAt: loadedMessages[0].createdAt
              } : null,
              lastMessage: loadedMessages[loadedMessages.length - 1] ? {
                id: loadedMessages[loadedMessages.length - 1].id,
                body: loadedMessages[loadedMessages.length - 1].body,
                createdAt: loadedMessages[loadedMessages.length - 1].createdAt
              } : null,
              pageNumber: data.pageNumber || pageNumber,
              hasMore: data.hasMore
            });
            dispatch({ type: "LOAD_MESSAGES", ticketId: ticketKey, payload: data.messages });
            setHasMoreByTicket(prev => ({ ...prev, [ticketKey]: data.hasMore }));
            setLoadingByTicket(prev => ({ ...prev, [ticketKey]: false }));
            setLoadingMoreByTicket(prev => ({ ...prev, [ticketKey]: false }));
            setInitializedByTicket(prev => ({ ...prev, [ticketKey]: true }));
            setPageNumberByTicket(prev => ({ ...prev, [ticketKey]: Number(data.pageNumber || pageNumber) }));
            focusedApiPageRef.current = Number(data.pageNumber || pageNumber);
          }
        } catch (err) {
          if (requestSeqRef.current === requestId && currentTicketId.current === ticketId) {
            setLoadingByTicket(prev => ({ ...prev, [ticketKey]: false }));
            setLoadingMoreByTicket(prev => ({ ...prev, [ticketKey]: false }));
            toastError(err);
          }
        }
      };

      fetchMessages();
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [pageNumber, ticketId, ticketKey, ticketDbId, ticketUuid, focusedMessageId, initialized, loadingMore, history, selectedQueuesMessage]);

  const syncMessagesAfterLastKnown = async (reason = "socket_reconnect") => {
    const current = selectedTicketRef.current || {};
    const currentKey = normalizeTicketKey(current.key || current.id);
    if (!currentKey || current.id === "undefined") return;

    const localMessages = messagesByTicketRef.current[currentKey] || [];
    const lastLocalMessage = localMessages[localMessages.length - 1] || null;
    if (!lastLocalMessage?.id && !lastLocalMessage?.createdAt) return;

    try {
      console.log("[FRONTEND_SOCKET_RECONNECTED]", {
        socketId: socket?.id || null,
        companyId,
        selectedTicketId: current.id || null,
        lastMessageId: lastLocalMessage?.id || null,
        wid: lastLocalMessage?.wid || null,
        reason
      });

      const { data } = await api.get("/messages/" + current.id, {
        params: {
          selectedQueues: JSON.stringify(selectedQueuesMessage),
          afterMessageId: lastLocalMessage?.id || undefined,
          afterCreatedAt: lastLocalMessage?.createdAt || undefined
        }
      });

      const missedMessages = data?.messages || [];
      if (missedMessages.length > 0) {
        dispatch({ type: "LOAD_MESSAGES", ticketId: currentKey, payload: missedMessages });
        console.log("[FRONTEND_MESSAGE_STATE_UPDATED]", {
          socketId: socket?.id || null,
          companyId,
          selectedTicketId: current.id || null,
          count: missedMessages.length,
          reason
        });
      }
    } catch (err) {
      console.warn("[FRONTEND_SOCKET_RECONNECT_SYNC_FAILED]", {
        companyId,
        selectedTicketId: current.id || null,
        reason,
        error: err?.message || String(err)
      });
    }
  };

  useEffect(() => {
    if (ticketId === "undefined") {
      return;
    }
    if (!socket || typeof socket.on !== "function") {
      console.warn("[SOCKET] messagesList listener skipped: socket not ready", {
        event: "socket_listener_not_ready",
        ticketId
      });
      return;
    }

    const companyId = user.companyId;

    const connectEventMessagesList = () => {
      socket.emit("joinChatBox", `${ticketId}`);
      console.log("[SOCKET] Joined chat box", {
        event: "socket.join_chatbox",
        ticketId,
        companyId,
        socketId: socket.id,
        namespace: socket.nsp.name
      });
      syncMessagesAfterLastKnown("socket_connect");
    }

    const disconnectEventMessagesList = (reason) => {
      console.log("[FRONTEND_SOCKET_DISCONNECTED]", {
        socketId: socket.id,
        companyId,
        selectedTicketId: ticketId,
        reason
      });
    };

    const reconnectEventMessagesList = (attempt) => {
      console.log("[FRONTEND_SOCKET_RECONNECTED]", {
        socketId: socket.id,
        companyId,
        selectedTicketId: ticketId,
        attempt
      });
      socket.emit("joinChatBox", `${ticketId}`);
      syncMessagesAfterLastKnown("socket_reconnect");
    };

    const onAppMessageMessagesList = (data) => {
      console.log("[SOCKET] realtime_frontend_appMessage_received", {
        event: "realtime_frontend_appMessage_received",
        companyId,
        action: data.action,
        ticketId: data.ticket?.id || data.message?.ticket?.id || null,
        messageId: data.message?.id || null
      });
      // ✅ INSTRUMENTAÇÃO: Log quando recebe evento de mensagem com traceId
      const traceId = data.traceId || "unknown";
      const ENABLE_TRACE_LOGS = import.meta.env.VITE_ENABLE_TRACE_LOGS === "true" || import.meta.env.DEV;
      
      // ✅ INSTRUMENTAÇÃO: Log padronizado quando recebe mensagem (sempre, não apenas em trace mode)
      console.log("[SOCKET] Received appMessage", {
        event: "frontend_received_appMessage",
        action: data.action,
        ticketId: data.ticket?.id || data.message?.ticket?.id,
        ticketUuid: data.ticket?.uuid || data.message?.ticket?.uuid,
        currentTicketId: ticketId,
        messageId: data.message?.id,
        fromMe: data.message?.fromMe,
        traceId: data.traceId || "unknown",
        // DEBUG: Verificar campos de grupo
        participant: data.message?.participant,
        hasDataJson: !!data.message?.dataJson,
        dataJsonLen: data.message?.dataJson?.length || 0
      });
      console.log("[SOCKET_APP_MESSAGE]", {
        action: data.action,
        ticketId: data.ticket?.id || data.message?.ticket?.id || data.message?.ticketId || null,
        ticketUuid: data.ticket?.uuid || data.message?.ticket?.uuid || null,
        currentTicketId: ticketId,
        currentTicketDbId: ticketDbId || null,
        messageId: data.message?.id || null,
        body: data.message?.body || null
      });
      
      if (ENABLE_TRACE_LOGS) {
        console.log(`[TRACE] ${traceId} frontend.appMessage.received`, {
          action: data.action,
          ticketId: data.ticket?.id || data.message?.ticket?.id,
          ticketUuid: data.ticket?.uuid || data.message?.ticket?.uuid,
          currentTicketId: ticketId,
          messageId: data.message?.id,
          fromMe: data.message?.fromMe,
          traceId
        });
      }
      
      // ✅ GROUP_DEBUG: Log quando recebe evento de mensagem
      if (import.meta.env.VITE_ENABLE_GROUP_DEBUG === "true") {
        console.log("[GROUP_DEBUG] appMessage event received", {
          action: data.action,
          ticketId: data.ticket?.id || data.message?.ticket?.id,
          ticketUuid: data.ticket?.uuid || data.message?.ticket?.uuid,
          currentTicketId: ticketId,
          isGroup: data.ticket?.isGroup || data.message?.ticket?.isGroup || false,
          contactIsGroup: data.ticket?.contact?.isGroup || data.message?.ticket?.contact?.isGroup || false,
          messageId: data.message?.id,
          fromMe: data.message?.fromMe,
          traceId
        });
      }

      const currentSelectedTicket = {
        ...selectedTicketRef.current,
        id: ticketId,
        dbId: ticketDbId,
        uuid: ticketUuid,
        key: ticketKey
      };
      const currentTicketIdentity = ticketIdentityByKey.current[ticketKey] || {};
      const isCurrentTicketEvent = sameTicket({
        selectedTicket: {
          ...currentSelectedTicket,
          dbId: currentSelectedTicket.dbId || currentTicketIdentity.id,
          uuid: currentSelectedTicket.uuid || currentTicketIdentity.uuid
        },
        message: data.message,
        ticket: data.ticket
      });

      console.log(isCurrentTicketEvent ? "[FRONTEND_APP_MESSAGE_ACCEPTED]" : "[FRONTEND_APP_MESSAGE_REJECTED]", {
        socketId: socket.id,
        companyId,
        selectedTicketId: ticketId,
        payloadTicketId: data.message?.ticketId || data.message?.ticket?.id || data.ticket?.id || null,
        payloadTicketUuid: data.message?.ticket?.uuid || data.ticket?.uuid || null,
        messageId: data.message?.id || null,
        wid: data.message?.wid || null,
        action: data.action,
        reason: isCurrentTicketEvent ? "same_ticket" : "different_ticket"
      });

      if (data.action === "create" && isCurrentTicketEvent) {
        const shouldAutoScroll = data.message?.fromMe || isNearBottom();
        const incomingMessageKey = getMessageKey(data.message);
        if (shouldAutoScroll) {
          pendingSocketAutoScrollRef.current = {
            ticketId: ticketKey,
            lastMessageKey: incomingMessageKey,
            reason: data.message?.fromMe ? "SOCKET_FROM_ME" : "USER_AT_BOTTOM"
          };
        }
        dispatch({ type: "ADD_MESSAGE", ticketId: ticketKey, payload: data.message });
      }

      if (
        data.action === "update" &&
        isCurrentTicketEvent
      ) {
        console.log("[SOCKET-UPDATE]", {
          hasMessage: !!data?.message,
          messageId: data?.message?.id,
          body: data?.message?.body,
          mediaType: data?.message?.mediaType,
          hasContact: !!data?.message?.contact,
          hasQuotedMsg: !!data?.message?.quotedMsg,
          hasTicket: !!data?.message?.ticket || !!data?.ticket,
          raw: data
        });
        dispatch({ type: "UPDATE_MESSAGE", ticketId: ticketKey, payload: data.message });
      }

      if (
        data.action === "delete" &&
        isCurrentTicketEvent
      ) {
        const deletedMessageId = data.messageId || data.message?.id;
        dispatch({ type: "DELETE_MESSAGE", ticketId: ticketKey, payload: deletedMessageId });
      }
    }
    socket.on("connect", connectEventMessagesList);
    socket.on("disconnect", disconnectEventMessagesList);
    socket.io?.on?.("reconnect", reconnectEventMessagesList);
    socket.on(`company-${companyId}-appMessage`, onAppMessageMessagesList);

    return () => {
      socket.emit("joinChatBoxLeave", `${ticketId}`)
      socket.off("connect", connectEventMessagesList);
      socket.off("disconnect", disconnectEventMessagesList);
      socket.io?.off?.("reconnect", reconnectEventMessagesList);
      socket.off(`company-${companyId}-appMessage`, onAppMessageMessagesList);
    };

  }, [ticketId, ticketKey, ticketDbId, ticketUuid, socket, user.companyId, selectedQueuesMessage]);

  useEffect(() => {
    console.log("[CHAT_RENDER]", {
      ticketId,
      ticketDbId: ticketDbId || null,
      messageCount: messagesList.length,
      lastMessageId: lastMessageKey,
      ...getScrollSnapshot()
    });
  }, [ticketId, ticketDbId, messagesList.length, lastMessageKey]);

  useEffect(() => {
    return () => {
      if (dragTimeout) {
        clearTimeout(dragTimeout);
      }
    };
  }, [dragTimeout]);

  useLayoutEffect(() => {
    const messagesListElement = getMessagesContainer();
    if (!messagesListElement) return;

    const pendingPrepend = pendingPrependScrollRef.current;
    if (pendingPrepend?.ticketId === ticketKey) {
      const before = getScrollSnapshot();
      messagesListElement.scrollTop =
        messagesListElement.scrollHeight -
        pendingPrepend.scrollHeight +
        pendingPrepend.scrollTop;
      const after = getScrollSnapshot();
      console.log("[LOAD_OLDER_MESSAGES]", {
        ticketId: ticketKey,
        scrollBefore: before,
        scrollAfter: after
      });
      pendingPrependScrollRef.current = null;
      return;
    }

    const pendingInitial = initialScrollPendingRef.current;
    if (pendingInitial?.ticketId === ticketKey && messagesList.length > 0 && !loading) {
      initialScrollPendingRef.current = null;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (pendingInitial.focusedMessageId) {
            scrollToFocusedMessage(pendingInitial.focusedMessageId);
          } else {
            scrollToBottom("OPEN", true);
          }
        });
      });
      return;
    }

    const pendingSocket = pendingSocketAutoScrollRef.current;
    if (
      pendingSocket?.ticketId === ticketKey &&
      pendingSocket.lastMessageKey === lastMessageKey &&
      messagesList.length > 0
    ) {
      pendingSocketAutoScrollRef.current = null;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToBottom(pendingSocket.reason, true);
        });
      });
    }
  }, [messagesList.length, lastMessageKey, ticketKey, loading]);

  const loadMore = () => {
    if (loading || loadingMore || !hasMore) return;

    const messagesListElement = getMessagesContainer();
    if (messagesListElement) {
      pendingPrependScrollRef.current = {
        ticketId: ticketKey,
        scrollHeight: messagesListElement.scrollHeight,
        scrollTop: messagesListElement.scrollTop
      };
    }

    const nextPageNumber = (pageNumberByTicket[ticketKey] || focusedApiPageRef.current || 1) + 1;
    setLoadingMoreByTicket(prev => ({ ...prev, [ticketKey]: true }));
    setPageNumberByTicket(prev => ({ ...prev, [ticketKey]: nextPageNumber }));
    focusedApiPageRef.current = nextPageNumber;
  };

  const scrollToFocusedMessage = (messageId) => {
    if (!messageId) return;

    requestAnimationFrame(() => {
      const target = messageRefs.current[String(messageId)];
      if (!target) return;

      target.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
  };

  const scrollToBottom = (reason = "UNKNOWN", force = false) => {
    const messagesListElement = getMessagesContainer();
    if (!messagesListElement) return;

    const before = getScrollSnapshot();

    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: force ? "auto" : "smooth",
        block: "end",
        inline: "nearest"
      });
    }

    const distanceFromBottom =
      messagesListElement.scrollHeight -
      (messagesListElement.scrollTop + messagesListElement.clientHeight);

    if (distanceFromBottom > 2) {
      messagesListElement.scrollTop = Math.max(
        0,
        messagesListElement.scrollHeight - messagesListElement.clientHeight
      );
    }

    const after = getScrollSnapshot();
    logAutoScroll(reason, before, after);
    updateScrollToLatestVisibility(messagesListElement);

    if (reason === "OPEN") {
      [80, 240, 600].forEach((delay) => {
        setTimeout(() => {
          const retryBefore = getScrollSnapshot();
          if (!isNearBottom()) {
            if (lastMessageRef.current) {
              lastMessageRef.current.scrollIntoView({
                behavior: "auto",
                block: "end",
                inline: "nearest"
              });
            }
            const retryElement = getMessagesContainer();
            if (retryElement) {
              retryElement.scrollTop = Math.max(
                0,
                retryElement.scrollHeight - retryElement.clientHeight
              );
            }
            logAutoScroll("OPEN_RETRY", retryBefore, getScrollSnapshot());
            updateScrollToLatestVisibility(retryElement);
          }
        }, delay);
      });
    }
  };

  const isNearBottom = () => {
    const messagesListElement = getMessagesContainer();
    return isNearBottomElement(messagesListElement);
  };

  const handleScroll = (e) => {
    updateScrollToLatestVisibility(e.currentTarget);
    if (!hasMore) return;
    const { scrollTop } = e.currentTarget;

    if (scrollTop === 0) {
      e.currentTarget.scrollTop = 1;
    }

    if (loading || loadingMore) {
      return;
    }

    if (scrollTop < 50) {
      loadMore();
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const hanldeReplyMessage = (e, message) => {
    setAnchorEl(null);
    setReplyingMessage(message);
  };

  const handleOpenQuickReaction = (e, message) => {
    e.stopPropagation();
    setQuickReactionAnchorEl(e.currentTarget);
    setQuickReactionMessage(message);
  };

  const handleCloseQuickReaction = () => {
    setQuickReactionAnchorEl(null);
    setQuickReactionMessage(null);
  };

  const handleSelectQuickReaction = async (emoji) => {
    if (!quickReactionMessage?.id) return;

    try {
      await api.post(`/messages/${quickReactionMessage.id}/reaction`, {
        emoji: resolveReactionPayload(quickReactionMessage, emoji)
      });
    } catch (err) {
      toastError(err);
    }

    handleCloseQuickReaction();
  };

  const handleQuickForward = (e, message) => {
    e.stopPropagation();
    setSelectedMessages([message]);
    setShowSelectMessageCheckbox(false);
    setForwardMessageModalOpen(true);
  };

  const renderOutsideActions = (message, { showReaction = false, showForward = false } = {}) => (
    <div
      className={clsx(classes.messageOutsideActions, {
        [classes.messageOutsideActionsLeft]: !message.fromMe,
        [classes.messageOutsideActionsRight]: message.fromMe,
      })}
    >
      {showReaction && (
        <IconButton
          variant="contained"
          size="small"
          className={classes.messageActionsButton}
          onClick={(e) => handleOpenQuickReaction(e, message)}
        >
          <InsertEmoticon fontSize="small" />
        </IconButton>
      )}

      {showForward && (
        <IconButton
          variant="contained"
          size="small"
          className={classes.messageActionsButton}
          onClick={(e) => handleQuickForward(e, message)}
        >
          <Reply style={{ transform: "scaleX(-1)" }} fontSize="small" />
        </IconButton>
      )}
    </div>
  );

  const renderInsideMenuAction = (message) => (
    <div
      className={clsx(classes.messageMenuInside, {
        [classes.messageMenuInsideLeft]: !message.fromMe,
        [classes.messageMenuInsideRight]: message.fromMe,
      })}
    >
      <IconButton
        variant="contained"
        size="small"
        id="messageActionsButton"
        disabled={message.isDeleted}
        className={clsx(classes.messageActionsButton, classes.messageActionsButtonInside)}
        onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
      >
        <ExpandMore />
      </IconButton>
    </div>
  );

  const getBasename = (filepath) => {
    if (!filepath) return '';
    // Remove query strings e hashes
    const cleanPath = filepath.split('?')[0].split('#')[0];
    // Pega o último segmento após /
    const segments = cleanPath.split('/');
    return segments[segments.length - 1];
  };

  // ✅ Formatar número de telefone brasileiro
  const formatPhoneNumber = (number) => {
    if (!number) return null;
    
    // Remover sufixos do WhatsApp e caracteres não numéricos
    const cleanNumber = number
      .replace('@s.whatsapp.net', '')
      .replace('@c.us', '')
      .replace('@lid', '')
      .replace(/\D/g, '');
    
    // Formatar como número de telefone brasileiro se aplicável
    if (cleanNumber.length === 13 && cleanNumber.startsWith('55')) {
      const ddd = cleanNumber.substring(2, 4);
      const part1 = cleanNumber.substring(4, 9);
      const part2 = cleanNumber.substring(9);
      return `+55 (${ddd}) ${part1}-${part2}`;
    }
    
    if (cleanNumber.length === 12 && cleanNumber.startsWith('55')) {
      const ddd = cleanNumber.substring(2, 4);
      const part1 = cleanNumber.substring(4, 8);
      const part2 = cleanNumber.substring(8);
      return `+55 (${ddd}) ${part1}-${part2}`;
    }
    
    if (cleanNumber.length > 0) {
      return `+${cleanNumber}`;
    }
    
    return null;
  };

  // ✅ Extrair nome do remetente para mensagens de grupo (nome + número)
  const getGroupMessageSenderName = (message) => {
    if (!isGroup || message.fromMe) return null;
    
    let senderName = null;
    let senderNumber = null;
    
    // 1. Tentar extrair do dataJson (contém pushName do remetente original)
    if (message.dataJson) {
      try {
        const msgData = typeof message.dataJson === 'string' 
          ? JSON.parse(message.dataJson) 
          : message.dataJson;
        
        // pushName é o nome de exibição do WhatsApp do remetente
        if (msgData.pushName && msgData.pushName.trim() !== '') {
          senderName = msgData.pushName.trim();
        }
        
        // verifiedBizName para contas business
        if (!senderName && msgData.verifiedBizName && msgData.verifiedBizName.trim() !== '') {
          senderName = msgData.verifiedBizName.trim();
        }
        
        // participantAlt contém o número real quando participant é @lid
        if (msgData.key?.participantAlt) {
          senderNumber = formatPhoneNumber(msgData.key.participantAlt);
        }
        
        // participant do key no dataJson se não for @lid
        if (!senderNumber && msgData.key?.participant && !msgData.key.participant.includes('@lid')) {
          senderNumber = formatPhoneNumber(msgData.key.participant);
        }
      } catch (e) {
        // Ignore parse errors silently
      }
    }
    
    // 2. Usar participant se disponível e não for @lid
    if (!senderNumber && message.participant && !message.participant.includes('@lid')) {
      senderNumber = formatPhoneNumber(message.participant);
    }
    
    // 3. Montar string de retorno: nome + número ou apenas um deles
    if (senderName && senderNumber) {
      return `${senderName} | ${senderNumber}`;
    } else if (senderName) {
      return senderName;
    } else if (senderNumber) {
      return senderNumber;
    }
    
    // 4. Fallback - não retornar nome do grupo
    return null;
  };

  const checkMessageMedia = (message) => {
    if (!message) return null;
    const safeBody = typeof message.body === "string" ? message.body : "";

    const isAudioMessage = (message) => {
      if (message.mediaType === "audio") {
        console.log("🎵 Detectado como áudio pelo mediaType:", message.mediaType);
        return true;
      }

      if (message.mediaUrl) {
        const audioExtensions = ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.webm'];
        const url = message.mediaUrl.toLowerCase();
        const hasAudioExtension = audioExtensions.some(ext => url.includes(ext));

        if (hasAudioExtension) {
          console.log("🎵 Detectado como áudio pela URL:", url);
          return true;
        }
      }

      if (message.body && typeof message.body === 'string') {
        const body = message.body.toLowerCase();
        const isAudioBody = body.includes('áudio gravado') ||
          body.includes('audio_') ||
          body.includes('🎵') ||
          body.includes('arquivo de áudio') ||
          body.includes('mensagem de voz');

        if (isAudioBody) {
          console.log("🎵 Detectado como áudio pelo body:", body);
          return true;
        }
      }

      return false;
    };

    const wrapMedia = (content) => {
      return <div className={classes.mediaWrapper}>{content}</div>;
    };

    // Templates
    if (message.mediaType === "template") {
      return wrapMedia(<Template message={message} />);
    }

    // Localização
    else if (message.mediaType === "locationMessage" && safeBody.split('|').length >= 2) {
      let locationParts = safeBody.split('|');
      let imageLocation = locationParts[0];
      let linkLocation = locationParts[1];
      let descriptionLocation = locationParts.length > 2 ? locationParts[2] : null;

      return wrapMedia(<LocationPreview 
        image={imageLocation} 
        link={linkLocation} 
        description={descriptionLocation} 
      />);
    }

    // Contatos
    else if (message.mediaType === "contactMessage") {
      let array = safeBody.split("\n");
      let obj = [];
      let contact = "";
      
      for (let index = 0; index < array.length; index++) {
        const v = array[index];
        let values = v.split(":");
        for (let ind = 0; ind < values.length; ind++) {
          if (values[ind].indexOf("+") !== -1) {
            obj.push({ number: values[ind] });
          }
          if (values[ind].indexOf("FN") !== -1) {
            contact = values[ind + 1];
          }
        }
      }
      
      return wrapMedia(<VcardPreview 
        contact={contact} 
        numbers={obj[0]?.number} 
        queueId={message?.ticket?.queueId} 
        whatsappId={message?.ticket?.whatsappId} 
        channel={channel} 
      />);
    }

    else if (message.mediaType === "adMetaPreview") { // Adicionado para renderizar o componente de preview de anúncio
      console.log("Entrou no MetaPreview");
      // ✅ CORREÇÃO: Parse correto dos dados - formato: image|sourceUrl|title|body|messageUser
      let [image, sourceUrl, title, body, messageUser] = safeBody.split('|');
      
      // Fallback para messageUser se não estiver presente
      if (!messageUser || messageUser.trim() === "") {
        messageUser = "Olá! Tenho interesse e queria mais informações, por favor.";
      }
      
      return wrapMedia(<AdMetaPreview 
        image={image} 
        sourceUrl={sourceUrl} 
        title={title} 
        body={body} 
        messageUser={messageUser} 
      />);
    }

    else if (message.mediaType === "facebookPostPreview") { // ✅ NOVO: Preview de post do Facebook
      // Formato: image|url|title|body|comment
      let [image, sourceUrl, title, body, comment] = safeBody.split('|');
      
      return wrapMedia(<FacebookPostPreview 
        image={image} 
        sourceUrl={sourceUrl} 
        title={title} 
        body={body} 
        comment={comment} 
      />);
    }

    // PDF e Documentos - SÓ DOWNLOAD
    else if (isPdfUrl(message.mediaUrl, message.body, message.mediaType)) {
      
      console.log("📄 Renderizando como documento/PDF:", message.id);
      // ✅ CORRIGIDO: Passar companyId para construir a URL correta
      const pdfInfo = extractPdfInfoFromMessage(message, companyId);

      return wrapMedia(
        <PdfPreview
          url={pdfInfo.url}
          filename={pdfInfo.filename}
          size={pdfInfo.size}
          mediaType={pdfInfo.mediaType}
          onDownload={(url, name) => {
            console.log("📥 Download PDF solicitado:", { url, name });
            downloadPdf(url, name, pdfInfo.messageId);
          }}
        />
      );
    }

    // Áudio
    else if (isAudioMessage(message)) {
      console.log("🎵 Renderizando como áudio:", message.id);
      return wrapMedia(
        <AudioModal
          url={message.mediaUrl}
          message={message}
        />
      );
    }

    // Imagens
    else if (message.mediaType === "image") {
      console.log("🖼️ Renderizando como imagem");
      // ✅ CORRIGIDO: O mediaUrl já vem do backend com a URL completa construída pelo modelo Message
      // O modelo Message constrói: ${BACKEND_URL}/public/company${companyId}/${mediaUrl}
      // Se mediaUrl = "flow/logo-swl-plus.png", a URL final será: ${BACKEND_URL}/public/company1/flow/logo-swl-plus.png
      // Então não precisamos fazer nenhuma transformação aqui, apenas usar o mediaUrl diretamente
      const imageUrl = message.mediaUrl || '';
      return wrapMedia(
        <ModalImageCors
          imageUrl={imageUrl}
          filename={message.body || message.mediaName || "imagem"}
          createdAt={message.createdAt}
          fromMe={message.fromMe}
        />
      );
    }

    // Vídeos
    else if (message.mediaType === "video") {
      console.log("🎥 Renderizando como vídeo");
      
      return wrapMedia(
        <div style={{ maxWidth: "400px", width: "100%", position: "relative" }}>
          {/* Loading indicator */}
          {videoLoading && !videoError && (
            <div style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px"
            }}>
              <CircularProgress size={30} />
              <Typography variant="caption" color="textSecondary">
                Carregando vídeo...
              </Typography>
            </div>
          )}
          
          {/* Vídeo player melhorado */}
          <video
            className={classes.messageMedia}
            src={message.mediaUrl}
            controls
            preload="metadata"
            playsInline
            style={{ 
              width: "100%", 
              height: "auto", 
              maxHeight: "300px",
              borderRadius: "8px",
              backgroundColor: "#f0f0f0",
              opacity: videoLoading ? 0.3 : 1,
              transition: "opacity 0.3s ease"
            }}
            onLoadStart={() => {
              console.log("⏳ Iniciando carregamento do vídeo");
              setVideoLoading(true);
              setVideoError(false);
            }}
            onLoadedData={() => {
              console.log("✅ Vídeo carregado e pronto");
              setVideoLoading(false);
            }}
            onCanPlay={() => {
              console.log("✅ Vídeo pronto para reprodução");
              setVideoLoading(false);
            }}
            onError={(e) => {
              console.error("❌ Erro ao carregar vídeo:", e);
              console.log("🔗 URL do vídeo:", message.mediaUrl);
              setVideoLoading(false);
              setVideoError(true);
            }}
          >
            {/* ✅ CORREÇÃO: Múltiplos formatos para compatibilidade */}
            <source src={message.mediaUrl} type="video/mp4" />
            <source src={message.mediaUrl} type="video/webm" />
            <source src={message.mediaUrl} type="video/ogg" />
            
            {/* Fallback para navegadores antigos */}
            {i18n.t("messagesList.video.unsupported")}
          </video>
          
          {/* Error state */}
          {videoError && (
            <div style={{ 
              padding: "20px", 
              textAlign: "center", 
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              color: "#666",
              marginTop: "8px"
            }}>
              <Typography variant="body2" style={{ marginBottom: "12px" }}>
                {i18n.t("messagesList.video.loadError")}
              </Typography>
              <Button
                startIcon={<GetApp />}
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = message.mediaUrl;
                  link.download = message.body || 'video.mp4';
                  link.click();
                }}
                variant="outlined"
                size="small"
              >
                Baixar Vídeo
              </Button>
            </div>
          )}
        </div>
      );
    }

    // Outros tipos de arquivo
    else if (message.mediaUrl) {
      console.log("📎 Renderizando como download genérico");
      const fileInfo = extractPdfInfoFromMessage(message, companyId);

      return wrapMedia(
        <PdfPreview
          url={fileInfo.url}
          filename={fileInfo.filename}
          size={fileInfo.size}
          mediaType={fileInfo.mediaType}
          onDownload={(url, name) => {
            console.log("📥 Download genérico solicitado:", { url, name });
            downloadPdf(url, name, fileInfo.messageId);
          }}
        />
      );
    }

    return null;
  };

  // ✅ REACTIONS: Função para renderizar reações
  const renderReactions = (message) => {
    if (!message.reactions || !Array.isArray(message.reactions) || message.reactions.length === 0) {
      return null;
    }

    // Agrupar reações por emoji
    const groupedReactions = {};
    message.reactions.forEach((reaction) => {
      if (reaction.emoji && reaction.emoji.trim() !== "") {
        if (!groupedReactions[reaction.emoji]) {
          groupedReactions[reaction.emoji] = [];
        }
        groupedReactions[reaction.emoji].push(reaction);
      }
    });

    const emojiKeys = Object.keys(groupedReactions);
    if (emojiKeys.length === 0) {
      return null;
    }

    return (
      <div className={classes.reactionsContainer}>
        {emojiKeys.map((emoji) => {
          const reactions = groupedReactions[emoji];
          const count = reactions.length;
          // Criar tooltip com lista de quem reagiu
          const tooltipText = reactions.map(r => {
            // Extrair número do JID (remover @s.whatsapp.net ou @g.us)
            const number = r.from?.replace(/@.*$/, "") || "Usuário";
            return number;
          }).join(", ");
          
          return (
            <div
              key={emoji}
              className={classes.reactionPill}
              title={tooltipText}
            >
              <span className={classes.reactionEmoji}>{emoji}</span>
              {count > 1 && <span className={classes.reactionCount}>{count}</span>}
            </div>
          );
        })}
      </div>
    );
  };

  const renderMessageAck = (message) => {
    if (message.ack === 0) {
      return <AccessTime fontSize="small" className={classes.ackIcons} />;
    } else
      if (message.ack === 1) {
        return <Done fontSize="small" className={classes.ackIcons} />;
      } else
        if (message.ack === 2 || message.ack === 3) {
          return <DoneAll fontSize="small" className={classes.ackIcons} />;
        } else
          if (message.ack === 4) {
            return <DoneAll fontSize="small" className={message.mediaType === "audio" ? classes.ackPlayedIcon : classes.ackDoneAllIcon} />;
          } else
            if (message.ack === 5) {
              return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />
            }
  };

  const shouldShowDateSeparator = (currentMessage, previousMessage) => {
    if (!currentMessage?.createdAt) return false;
    const currentDateStr = moment.utc(currentMessage.createdAt).tz(companyTimezone).format("YYYY-MM-DD");
    if (!previousMessage?.createdAt) {
      const todayStr = moment().tz(companyTimezone).format("YYYY-MM-DD");
      return currentDateStr !== todayStr;
    }
    const previousDateStr = moment.utc(previousMessage.createdAt).tz(companyTimezone).format("YYYY-MM-DD");
    return currentDateStr !== previousDateStr;
  };

  const renderDailyTimestamps = (message, index) => {
    const previousMessage = index > 0 ? messagesList[index - 1] : null;
    if (!shouldShowDateSeparator(message, previousMessage)) {
      return null;
    }

    return (
      <DateSeparator
        key={`timestamp-${message.id}`}
        label={formatDateSeparatorLabel(message?.createdAt)}
      />
    );
  };

  const renderTicketsSeparator = (message, index) => {
    let lastTicket = messagesList[index - 1]?.ticketId;
    let currentTicket = message.ticketId;

    if (lastTicket !== currentTicket && lastTicket !== undefined) {
      if (message?.ticket?.queue) {
        return (
          <span
            className={classes.currentTick}
            key={`timestamp-${message.id}a`}
          >
            <div
              className={classes.currentTicktText}
              style={{ backgroundColor: message?.ticket?.queue?.color || "grey" }}
            >
              #{i18n.t("ticketsList.called")} {getTicketDisplayNumber(message?.ticket) || message?.ticketId} - {message?.ticket?.queue?.name}
            </div>

          </span>
        );
      } else {
        return (
          <span
            className={classes.currentTick}
            key={`timestamp-${message.id}b`}
          >
            <div
              className={classes.currentTicktText}
              style={{ backgroundColor: "grey" }}
            >
              #{i18n.t("ticketsList.called")} {getTicketDisplayNumber(message?.ticket) || message.ticketId} - {i18n.t("ticketsList.noQueue")}
            </div>

          </span>
        );
      }
    }

  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;
      if (messageUser !== previousMessageUser) {
        return (

          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {
    if (!message.quotedMsg) return null;

    // ✅ Extrair bodyResolved do dataJson se disponível (para substituir menções @LID por nomes)
    let quotedBody = message.quotedMsg?.body;
    if (message.quotedMsg?.dataJson) {
      try {
        const dataJson = typeof message.quotedMsg.dataJson === 'string' 
          ? JSON.parse(message.quotedMsg.dataJson) 
          : message.quotedMsg.dataJson;
        if (dataJson?.bodyResolved) {
          quotedBody = dataJson.bodyResolved;
        }
      } catch (e) {
        // Ignorar erro de parse, usar message.quotedMsg.body como fallback
      }
    }

    const quotedMediaType = String(message.quotedMsg?.mediaType || "").toLowerCase();
    const quotedMediaUrl = String(message.quotedMsg?.mediaUrl || "").toLowerCase();
    const isQuotedAudio =
      quotedMediaType === "audio" ||
      quotedMediaType === "audiomessage" ||
      /\.(mp3|wav|ogg|m4a|aac|webm)(\?|$)/.test(quotedMediaUrl);

    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        ></span>
        <div className={classes.quotedMsg}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.contact?.name}
            </span>
          )}

          {isQuotedAudio &&
            (message.quotedMsg?.mediaUrl ? (
              <AudioModal
                url={message.quotedMsg.mediaUrl}
                message={message.quotedMsg}
                disableTranscription={true}
              />
            ) : (
              i18n.t("messagesList.audioMessage")
            ))}
          {message.quotedMsg.mediaType === "video"
            && (
              <div style={{ maxWidth: "300px", width: "100%" }}>
                <video
                  className={classes.messageMedia}
                  src={message.quotedMsg.mediaUrl}
                  controls
                  preload="metadata"
                  style={{ 
                    width: "100%", 
                    height: "auto", 
                    maxHeight: "200px",
                    borderRadius: "6px",
                    backgroundColor: "#f0f0f0"
                  }}
                  onError={(e) => {
                    console.error("❌ Erro ao carregar vídeo citado:", e);
                  }}
                >
                  <source src={message.quotedMsg.mediaUrl} type="video/mp4" />
                  <source src={message.quotedMsg.mediaUrl} type="video/webm" />
                  <source src={message.quotedMsg.mediaUrl} type="video/ogg" />
                  <div style={{ padding: "10px", textAlign: "center", fontSize: "12px", color: "#999" }}>
                    {i18n.t("messagesList.video.loadError")}
                  </div>
                </video>
              </div>
            )
          }
          {message.quotedMsg.mediaType === "contactMessage"
            && (
              "Contato"
            )
          }
          {message.quotedMsg.mediaType === "application"
            && (
              <div className={classes.downloadMedia}>
                <Button
                  startIcon={<GetApp />}
                  variant="outlined"
                  target="_blank"
                  href={message.quotedMsg.mediaUrl}
                >
                  Download
                </Button>
              </div>
            )
          }

          {isQuotedAudio ? null : message.quotedMsg.mediaType === "image" ? (
            <ModalImageCors
              imageUrl={message.quotedMsg.mediaUrl}
              filename={message.quotedMsg.body || message.quotedMsg.mediaName || "imagem"}
              createdAt={message.quotedMsg.createdAt}
              fromMe={message.quotedMsg.fromMe}
            />
          ) : (
            quotedBody && <MarkdownWrapper>{quotedBody}</MarkdownWrapper>
          )}

        </div>
      </div>
    );
  };

  const handleDrag = event => {
    event.preventDefault();
    event.stopPropagation();

    if (event.type === "dragenter" || event.type === "dragover") {
      const hasFiles = event.dataTransfer &&
        event.dataTransfer.types &&
        (event.dataTransfer.types.includes('Files') ||
          event.dataTransfer.types.includes('application/x-moz-file'));

      if (hasFiles) {
        if (dragTimeout) {
          clearTimeout(dragTimeout);
        }

        const timeout = setTimeout(() => {
          if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
            setDragActive(true);
          }
        }, 100);

        setDragTimeout(timeout);
      }
    } else if (event.type === "dragleave") {
      if (dragTimeout) {
        clearTimeout(dragTimeout);
        setDragTimeout(null);
      }

      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;

      if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
        setDragActive(false);
      }
    }
  }

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Permite o drop
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
  };

  const isYouTubeLink = (url) => {
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    return youtubeRegex.test(url);
  };

  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();

    if (dragTimeout) {
      clearTimeout(dragTimeout);
      setDragTimeout(null);
    }

    setDragActive(false);

    if (event.dataTransfer.files &&
      event.dataTransfer.files.length > 0 &&
      event.dataTransfer.files[0] instanceof File) {
      if (onDrop) {
        onDrop(event.dataTransfer.files);
      }
    }
  }
  const xmlRegex = /<([^>]+)>/g;
  const boldRegex = /\*(.*?)\*/g;

  const formatXml = (xmlString) => {
    // Verifica se o XML contém a assinatura com nome do atendente
    if (boldRegex.test(xmlString)) {
      // Formata o texto dentro da assinatura em negrito
      xmlString = xmlString.replace(boldRegex, "**$1**");
    }
    return xmlString;
  };

  const renderMessages = () => {

    if (messagesList.length > 0) {
      const viewMessagesList = messagesList.map((message, index) => {
        if (!message || !message.id) {
          return null;
        }

        // ✅ Extrair bodyResolved do dataJson se disponível (para substituir menções @LID por nomes)
        let displayBody = typeof message.body === "string" ? message.body : "";
        if (message.dataJson) {
          try {
            const dataJson = typeof message.dataJson === 'string' 
              ? JSON.parse(message.dataJson) 
              : message.dataJson;
            if (typeof dataJson?.bodyResolved === "string") {
              displayBody = dataJson.bodyResolved;
            }
          } catch (e) {
            // Ignorar erro de parse, usar message.body como fallback
          }
        }
        
        if (message.mediaType === "call_log") {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div className={classes.messageCenter}>
                {renderInsideMenuAction(message)}
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}

                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17">
                    <path fill="#df3333" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path>
                  </svg> <span>{i18n.t("ticketsList.missedCall")} {safeFormatDate(message?.createdAt, "HH:mm")}</span>
                </div>
              </div>
            </React.Fragment>
          );
        }

        if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div className={clsx(classes.messageRow, classes.messageRowLeft)}>
                <div className={classes.messageBubbleAnchor}>
                {renderOutsideActions(message, {
                  showReaction: !message.isDeleted,
                  showForward: message.mediaType === "image"
                })}
                <div
                  ref={element => {
                    if (element) {
                      messageRefs.current[String(message.id)] = element;
                    }
                  }}
                  className={clsx(classes.messageLeft, {
                    [classes.focusedMessage]: focusedMessageId && String(focusedMessageId) === String(message.id)
                  })}
                  title={message.queueId && message.queue?.name}
                  onDoubleClick={(e) => hanldeReplyMessage(e, message)}
                >
                {showSelectMessageCheckbox && (
                  <SelectMessageCheckbox
                    message={message}
                  />
                )}
                {renderInsideMenuAction(message)}

                {message.isForwarded && (
                  <div>
                    <span className={classes.forwardMessage}
                    ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> {i18n.t("messagesList.status.forwarded")}
                    </span>
                    <br />
                  </div>
                )}
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {getGroupMessageSenderName(message) || message.contact?.name}
                  </span>
                )}
                {isYouTubeLink(displayBody) && (
                  <>
                    <YouTubePreview videoUrl={displayBody} />
                  </>
                )}

                {!lgpdDeleteMessage && message.isDeleted && (
                  <div>
                    <span className={classes.deletedMessage}
                    >{i18n.t("messagesList.deletedMessageByContact")} &nbsp;
                    </span>
                  </div>
                )}

                {(message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template" || message.mediaType === "adMetaPreview" || message.mediaType === "facebookPostPreview"
                ) && checkMessageMedia(message)}

                <div className={clsx(classes.textContentItem, {
                  [classes.textContentItemDeleted]: message.isDeleted,
                })}>
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {
                    message.mediaType !== "adMetaPreview" && message.mediaType !== "facebookPostPreview" && (
                      (message.mediaUrl !== null && (message.mediaType === "image" || message.mediaType === "video") && getBasename(message.mediaUrl).trim() !== displayBody.trim()) ||
                      message.mediaType !== "audio" &&
                      message.mediaType !== "image" &&
                      message.mediaType !== "video" &&
                      message.mediaType != "reactionMessage" &&
                      message.mediaType != "locationMessage" &&
                      message.mediaType !== "contactMessage" &&
                      message.mediaType !== "template"
                    ) && (
                      <>
                        {xmlRegex.test(displayBody) && (
                          <span>{displayBody}</span>

                        )}
                        {!xmlRegex.test(displayBody) && (
                          <MarkdownWrapper onPhoneClick={handlePhoneClick}>{(lgpdDeleteMessage && message.isDeleted) ? i18n.t("messagesList.deletedMessageMarkdown") :
                            displayBody
                          }</MarkdownWrapper>)}

                      </>

                    )}

                  {message.quotedMsg && message.mediaType === "reactionMessage" && (
                    <>
                      <span style={{ marginLeft: "0px" }}>
                        <MarkdownWrapper>
                          {i18n.t("messagesList.reactions.contactReacted", { contact: message?.contact?.name, reaction: displayBody })}
                        </MarkdownWrapper>
                      </span>
                    </>
                  )}

                  <span className={clsx(classes.timestamp, classes.timestampIncoming)}>
                    {message.isEdited ? i18n.t("messagesList.status.editedAt", { time: safeFormatDate(message?.createdAt, "HH:mm") }) : safeFormatDate(message?.createdAt, "HH:mm")}
                  </span>
                </div>
                {/* ✅ REACTIONS: Renderizar reações abaixo da mensagem */}
                {renderReactions(message)}
                </div>
                </div>
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div className={clsx(classes.messageRow, classes.messageRowRight)}>
                <div className={classes.messageBubbleAnchor}>
                {renderOutsideActions(message, {
                  showReaction: !message.isDeleted,
                  showForward: message.mediaType === "image"
                })}
                <div
                  ref={element => {
                    if (element) {
                      messageRefs.current[String(message.id)] = element;
                    }
                  }}
                  className={clsx(message.isPrivate ? classes.messageRightPrivate : classes.messageRight, {
                    [classes.focusedMessage]: focusedMessageId && String(focusedMessageId) === String(message.id)
                  })}
                  title={message.queueId && message.queue?.name}
                  onDoubleClick={(e) => hanldeReplyMessage(e, message)}
                >
                {showSelectMessageCheckbox && (
                  <SelectMessageCheckbox
                    message={message}
                  />
                )}

                {renderInsideMenuAction(message)}
                {message.isForwarded && (
                  <div>
                    <span className={classes.forwardMessage}
                    ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> {i18n.t("messagesList.status.forwarded")}
                    </span>
                    <br />
                  </div>
                )}
                {isYouTubeLink(displayBody) && (
                  <>
                    <YouTubePreview videoUrl={displayBody} />
                  </>
                )}
                {!lgpdDeleteMessage && message.isDeleted && (
                  <div>
                    <span className={classes.deletedMessage}
                    >{i18n.t("messagesList.deletedMessage")} &nbsp;
                    </span>
                  </div>
                )}
                {(message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template" || message.mediaType === "adMetaPreview" || message.mediaType === "facebookPostPreview"
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                    [classes.textContentItemOutgoing]: !message.isDeleted,
                    [classes.textContentItemDeletedOutgoing]: message.isDeleted,
                  })}
                >

                  {message.quotedMsg && renderQuotedMessage(message)}

                  {
                    ((message.mediaType === "image" || message.mediaType === "video") && getBasename(message.mediaUrl) === displayBody) ||
                    (message.mediaType !== "audio" && message.mediaType != "reactionMessage" && message.mediaType != "locationMessage" && message.mediaType !== "contactMessage" && message.mediaType !== "template" && message.mediaType !== "adMetaPreview" && message.mediaType !== "facebookPostPreview") && (
                      <>
                        {xmlRegex.test(displayBody) && (
                          <div>{formatXml(displayBody)}</div>

                        )}
                        {!xmlRegex.test(displayBody) && (<MarkdownWrapper onPhoneClick={handlePhoneClick}>{displayBody}</MarkdownWrapper>)}

                      </>
                    )}

                  {message.quotedMsg && message.mediaType === "reactionMessage" && (
                    <>
                      <span style={{ marginLeft: "0px" }}>
                        <MarkdownWrapper>
                          {i18n.t("messagesList.reactions.youReacted", { reaction: displayBody })}
                        </MarkdownWrapper>
                      </span>
                    </>
                  )}

                  <span className={classes.timestamp}>
                    {message.isEdited ? i18n.t("messagesList.status.editedAt", { time: safeFormatDate(message?.createdAt, "HH:mm") }) : safeFormatDate(message?.createdAt, "HH:mm")}
                    {renderMessageAck(message)}
                  </span>
                </div>
                {/* ✅ REACTIONS: Renderizar reações abaixo da mensagem */}
                {renderReactions(message)}
                </div>
                </div>
              </div>
            </React.Fragment>
          );
        }
      });
      return viewMessagesList;
    } else {
      return <div>{i18n.t("messagesList.emptyNewContact")}</div>;
    }
  };
const shouldBlurMessages = ticketStatus === "pending" && user.allowSeeMessagesInPendingTickets === "disabled";

  return (
    <div 
      className={classes.messagesListWrapper} 
      onDragEnter={handleDrag}
      onDragOver={handleDragOver}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
    >
      {dragActive && <div className={classes.dragElement} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDragOver} onDrop={handleDrop}>{i18n.t("messagesList.dropFileHere")}</div>}
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
        isGroup={isGroup}
        whatsappId={whatsappId}
        queueId={queueId}
      />
      <ReactionPicker
        anchorEl={quickReactionAnchorEl}
        open={Boolean(quickReactionAnchorEl)}
        onClose={handleCloseQuickReaction}
        onSelectEmoji={handleSelectQuickReaction}
      />
      <Menu
        anchorEl={phoneMenuAnchorEl}
        classes={{ paper: classes.phoneMenuPaper }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={phoneMenuOpen}
        onClose={handleClosePhoneMenu}
      >
        {phoneMenuMeta.isPhone && (
          <MenuItem
            className={classes.phoneMenuItem}
            onClick={handleTalkToPhone}
            disabled={openingPhoneTicket}
          >
            <ListItemIcon style={{ minWidth: 36 }}>
              <Chat fontSize="small" />
            </ListItemIcon>
            <ListItemText
              className={classes.phoneMenuText}
              primary={`Conversar com +${phoneMenuNumber}`}
            />
          </MenuItem>
        )}
        <MenuItem className={classes.phoneMenuItem} onClick={handleCopyPhone}>
          <ListItemIcon style={{ minWidth: 36 }}>
            <FileCopy fontSize="small" />
          </ListItemIcon>
          <ListItemText
            className={classes.phoneMenuText}
            primary={phoneMenuMeta.isPhone ? "Copiar número de telefone" : "Copiar número"}
          />
        </MenuItem>
      </Menu>
      

<div
  id="messagesList"
  ref={messagesContainerRef}
  className={classes.messagesList}
  onScroll={handleScroll}
  onDragEnter={handleDrag}
  onDragOver={handleDragOver}
  onDragLeave={handleDrag}
  onDrop={handleDrop}
  style={{
    filter: shouldBlurMessages ? "blur(4px)" : "none",
    pointerEvents: shouldBlurMessages ? "none" : "auto"
  }}
>
  {messagesList.length > 0 ? renderMessages() : []}
  {/* ✅ CORREÇÃO: Elemento spacer no final para garantir que última mensagem seja sempre visível */}
  <div 
    ref={lastMessageRef}
    style={{ 
      height: "1px", 
      width: "100%", 
      clear: "both",
      minHeight: "20px" // ✅ CORREÇÃO: Espaço mínimo de 20px entre última mensagem e caixa de digitar
    }} 
  />
</div>

{showScrollToLatest && (
  <IconButton
    className={classes.scrollToLatestButton}
    onClick={() => scrollToBottom("BUTTON_LATEST", false)}
    aria-label="Voltar para mensagens recentes"
  >
    <KeyboardArrowDown />
  </IconButton>
)}

      {(channel !== "whatsapp" && channel !== undefined) && (
        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "10px",
            alignItems: "center",
            backgroundColor: "#E1F3FB",
          }}
        >
          {channel === "facebook" ? (
            <Facebook />
          ) : channel === "instagram" ? (
            <Instagram />
          ) : (
            <WhatsApp />
          )}

          <span>
            Você tem 24h para responder após receber uma mensagem, de acordo
            com as políticas da Meta.
          </span>
        </div>
      )}
      
      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}
    </div>
  );
};

export default MessagesList;
